// Minimal dependency-free toast bus.
// Why custom (instead of sonner): the existing sonner.jsx wrapper depends on next-themes which
// isn't set up here, and we want full control over the [UNDO] action affordance that powers
// the undo-able-delete pattern across the app.
//
// API:
//   showToast({ message, action?: { label, onClick }, duration?: ms, variant?: "info"|"success"|"error" })
//   dismissToast(id)
//   onToast(cb) -> unsubscribe
//
// Toasts auto-expire. When the user clicks ACTION the toast is dismissed immediately and the
// caller's callback fires. Caller is responsible for performing the undo (e.g., re-inserting
// the deleted row).

let _nextId = 1;
const listeners = new Set();

function notify(event) {
  listeners.forEach((fn) => {
    try { fn(event); } catch (err) { console.error("toast listener error", err); }
  });
}

export function showToast({ message, action, duration = 5000, variant = "info" } = {}) {
  if (!message) return null;
  const id = _nextId++;
  notify({ kind: "add", toast: { id, message, action, duration, variant, createdAt: Date.now() } });
  return id;
}

export function dismissToast(id) {
  if (id == null) return;
  notify({ kind: "dismiss", id });
}

export function onToast(cb) {
  listeners.add(cb);
  return () => listeners.delete(cb);
}
